export default __webpack_public_path__ + "static/media/burger.a55e9dfa.svg";